import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    width: 100%;
  }

  .creator-select {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-400);
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
  }

  .search-container {
    width: 100%;
    height: 56px;
    margin-bottom: 16px;
  }

  .list {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-300);
  }

  .creator-card {
    display: flex;
    align-items: center;
    padding: 12px;
    border-radius: var(--sds-size-radius-400);
    background: var(--sds-color-background-default-secondary);
    cursor: pointer;
    transition: all 0.2s ease;
    min-height: 56px;
    box-sizing: border-box;
  }

  .creator-card-image {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--sds-color-background-neutral-subtle);
    flex-shrink: 0;
    margin-right: 12px;
  }

  .creator-card-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .creator-card-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--sds-color-background-brand-bold);
    color: var(--sds-color-text-on-brand);
    font-weight: var(--sds-typography-weight-semibold);
    font-size: var(--sds-typography-body-size-small);
  }

  .creator-card-info {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
  }

  .creator-card-handle {
    font-family: var(--sds-typography-family-title);
    font-weight: var(--sds-typography-weight-medium);
    font-size: var(--sds-typography-body-size-medium);
    color: var(--sds-color-text-default-default);
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .creator-card-follow {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-200);
    margin-left: auto;
    flex-shrink: 0;
  }

  .follow-action {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-200);
    color: var(--sds-color-text-default-default);
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-medium);
    font-weight: var(--sds-typography-weight-medium);
  }

  .follow-action ph-plus-circle {
    color: var(--sds-color-icon-default-default);
    font-size: var(--sds-size-icon-small);
  }

  .follow-action ph-check-circle {
    color: var(--sds-color-icon-positive-default);
    font-size: var(--sds-size-icon-small);
  }

  .empty-state {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: var(--sds-size-space-800);
    color: var(--sds-color-text-default-secondary);
    text-align: center;
    font-family: var(--sds-typography-family-body);
  }

  .empty-state-title {
    font-size: var(--sds-typography-body-size-large);
    font-weight: var(--sds-typography-weight-medium);
    margin-bottom: var(--sds-size-space-200);
    color: var(--sds-color-text-default-default);
  }

  .empty-state-subtitle {
    font-size: var(--sds-typography-body-size-medium);
    color: var(--sds-color-text-default-secondary);
  }

  @media (max-width: 768px) {
    .creator-card-image {
      width: 28px;
      height: 28px;
      margin-right: 10px;
    }

    .creator-card-handle {
      font-size: var(--sds-typography-body-size-small);
    }

    .follow-action {
      font-size: var(--sds-typography-body-size-small);
      gap: var(--sds-size-space-150);
    }
  }

  @media (max-width: 480px) {
    .creator-card-image {
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }

    .creator-card-handle {
      font-size: var(--sds-typography-body-size-small);
    }

    .follow-action {
      font-size: var(--sds-typography-body-size-small);
    }
  }
`;
